import appToast from '../../helpers/toast';
import i18n from '../../i18n';
const { createSlice } = require('@reduxjs/toolkit');

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState: {
        wishlistItems: []
    },
    reducers: {
        addToWishlist(state, action) {
            const isInWishlist = state.wishlistItems.findIndex(item => item.id === action.payload.id);
            if(isInWishlist > -1){
                appToast.info(i18n.t("wishlist_already_added"), {position: "bottom-left"});
            } else {
                state.wishlistItems.push(action.payload);
                appToast.success(i18n.t("added_to_wishlist"), {position: "bottom-left"});
            }

        },
        deleteFromWishlist(state, action){
            state.wishlistItems = state.wishlistItems.filter(item => item.id !== action.payload);
            appToast.error(i18n.t("wishlist_removed"), {position: "bottom-left"});
        },
        deleteAllFromWishlist(state){
            state.wishlistItems = []
        }
    },
});

export const { addToWishlist, deleteFromWishlist, deleteAllFromWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
